import React, { Component } from 'react'
// import { Link } from 'react-router-dom';
// import axios from 'axios';
import { logger } from "../../util/logger";
import { post } from "../../util/axiosLib";

//css
import '../styles/auth/ConfirmNumber.css'
// assets
import Logo from '../../assets/logos/s-logo.svg'
// import Percent from '../../assets/svg/100.svg'
import Load from '../../assets/svg/other/loading2.svg'
// import { Redirect } from 'react-router-dom';


export default class ResetCode extends Component {
    

    componentDidMount(){
        const token = localStorage.getItem("tokenset");
        if (token === null ) {
            window.location="/"
        }
    }
   
    // Timer function
    
    // Auto tab inputs function 
    
    constructor (props) {
        super (props)
        this.state = {
            num1: 0,
        }
        
        this.inputNum1Ref = React.createRef()
        this.inputNum2Ref = React.createRef()
        this.inputNum3Ref = React.createRef()
        this.inputNum4Ref = React.createRef()
        this.inputNum5Ref = React.createRef()
        this.inputNum6Ref = React.createRef()
    }

    handleChange0 = async (event) => {
        await this.setState({ num6 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num6.length === 1) {
             this.inputNum1Ref.current.focus()
        }
    }
    handleChange1 = async (event) => {
        await this.setState({ num1 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num1.length === 1) {
             this.inputNum2Ref.current.focus()
        }
    }
    handleChange2 = async (event) => {
        await this.setState({ num2 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num2.length === 1) {
             this.inputNum3Ref.current.focus()
        }
    }
    handleChange3 = async (event) => {
        await this.setState({ num3 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num3.length === 1) {
             this.inputNum4Ref.current.focus()
        }
    }
    handleChange4 = async (event) => {
        await this.setState({ num4 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num4.length === 1) {
             this.inputNum5Ref.current.focus()
        }
    }
    handleChange5 = async (event) => {
        await this.setState({ num5 : event.target.value})  
        // console.log(this.state.num1)
        if(this.state.num5.length === 1) {
             this.inputNum6Ref.current.focus()
        }
    }

    handleSubmit = async (event) => {
        try {
            event.preventDefault();

            const otpCode = this.state.num1+this.state.num2+this.state.num3+this.state.num4+this.state.num5+this.state.num6

            // console.log(verifyCode)

            // load gif
            const loaded = document.getElementById("load");
            loaded.classList.add("load-gif-on");

            const token = localStorage.getItem("tokenset");

            const headers= {
                'authorization': `${token}`,
                // 'Content-Type': 'application/json', 
            }
        
            const otpDetails = {
                otpCode: otpCode,
            }

            if(navigator.onLine === true ) {

                const otpReq = await post(
                    `${process.env.REACT_APP_API_ENDPOINT}/auth/otpPassword/auth`,
                    otpDetails, headers
                );
                 
                const loaded = document.getElementById("load");
                loaded.classList.remove("load-gif-on");

                this.setState({ 
                    otherError: "",
                    incorrectError: "",
                    // successMsg:  "Code entered, loggin you in."
                    successMsg:  otpReq.data.message
                }); 

                logger(otpReq.data)

                window.location="/dashboard/home"

            }else {
                this.setState({ otherError: "Please check your network connection" }); 
            } 
        } catch (err) {
            
            logger("login ERROR::: ", err);
            if (err.isAxiosError) {
                const errData = err.response;
                const loaded = document.getElementById("load");
                loaded.classList.remove("load-gif-on");
                this.setState({ incorrectError: errData.data.error });
            } else {
            this.setState({ otherError: "Please check that the code is correct or request a new one." }); 
            }
        }   
    }
    
    render() {

        return (
            <div>
                 <section className="confirm-num">
                    <div className="confirm-num-container">
                        <div className="confirm-num-box">
                            <div className="confirm-num-content">
                                <div className="confirm-num-top">
                                    <div className="cn-logo-box">
                                        <img src={Logo} alt="logo" />
                                    </div>
                                    {/* <div className="zero-icon">
                                        <img src={Percent} alt="100%" />
                                    </div> */}
                                    <h1 className="login-title">OTP Code </h1>
                                    <p className="cn-details"> Please enter the alphanumeric code sent to your email</p>
                                </div>
                                <div className="confirm-num-body">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="cn-number-fields">
                                            <div>
                                                <input id="num1" type="text" maxLength="1" className="cn-inputs right-m2" 
                                                  ref={this.inputNum1Ref}
                                                  onChange={this.handleChange1}
                                                  required/>
                                            </div>
                                            <div>
                                                <input id="num2" name="num2" type="text" maxLength="1" className="cn-inputs  right-m2"
                                                ref={this.inputNum2Ref}
                                                onChange={this.handleChange2}
                                                required/>
                                            </div>
                                            <div>
                                                <input id="num3" name="num3" type="text" maxLength="1" className="cn-inputs  right-m2"
                                                 ref={this.inputNum3Ref}
                                                 onChange={this.handleChange3}
                                                 required/>
                                            </div>
                                            <div>
                                                <input id="num4"  type="text" maxLength="1" className="cn-inputs  right-m2"
                                                 ref={this.inputNum4Ref}
                                                 onChange={this.handleChange4}
                                                 required/>
                                            </div>
                                            <div>
                                                <input id="num5"  type="text" maxLength="1" className="cn-inputs  right-m2"
                                                ref={this.inputNum5Ref}
                                                onChange={this.handleChange5}
                                                required/>
                                            </div>
                                            <div>
                                                <input id="num6" type="text" maxLength="1" className="cn-inputs  right-m2"
                                                ref={this.inputNum6Ref}
                                                onChange={this.handleChange0}
                                                required/>
                                            </div>
                                        </div>

                                        <div className="cn-submit-box">
                                            <input className="cn-submit" type="submit" value="Submit"/>
                                        </div>
                                        <div className="load-gif" id="load">
                                            <img src={Load}  alt="loading"/>
                                        </div>

                                        <p className="errormsg2">{this.state.otherError}</p>
                                        <p className="errormsg2">{this.state.incorrectError}</p>
                                        <p className="successmsg">{this.state.successMsg}</p>
                                       

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
